import { debug } from '../../../utils';
import { createAjaxEpic } from '../utils';
import actions from './actions';
import { login, register, logout } from './actions';
const log = debug('lego:models/Auth/epics');

register.complete = [register.complete, (payload, {username, password}) => login({username, password})] as any;
const registerEpic = createAjaxEpic('/api/register/', register, 'post');

import cookie from 'react-cookie';
import { getProfile } from '../Profile';
import { getAccount } from '../Account';

login.complete = [login.complete, getProfile, getAccount] as any;
const loginEpic = createAjaxEpic('/api/login/', login, 'post');

import { clear as clearProfile } from '../Profile/actions';
import { clear as clearAccount } from '../Account/actions';
import { Observable as O } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
const logoutEpic = action$ => action$.ofType(actions.logout)
    .flatMap(() => {
		 cookie.remove('auth_hash', {path: '/'});
        cookie.remove('sessionid', {path: '/'});
        return [clearProfile(), clearAccount()];
    })
    .catch((err) => {
				log(`logout failed: `, err);
        return O.empty();
    });

export { loginEpic, registerEpic, logoutEpic };



// WEBPACK FOOTER //
// ./src/app/models/Auth/epics.ts